import { usingGet, usingPost, usingUpload, usingDelete, createProxyUrl } from '@ocean/api'
import { SessionUtils } from '@ocean/utils'
import { UserUtils } from 'utils'

export const getOnboardAssessmentDetails = (assessmentId: Guid) =>
  usingGet(`/assessments/details/obo/${assessmentId}`, { useProxy: true })

export const markOnboardAssessment = (assessmentId: Guid, IsReadyToBeAssessed: boolean) =>
  usingPost('Assessments/MarkOnboardAssessment', {
    activityId: assessmentId,
    IsReadyToBeAssessed,
  })

export const uploadAssessmentDocument = (activityId: Guid, files: File[]) => {
  const { login: userId } = UserUtils.getUserAccountInfo()
  const input = {
    activityId,
    userId,
  }
  const formData = new FormData()
  formData.append('BinaryMetadata', JSON.stringify(input))
  formData.append('BinaryData', files[0])
  return usingUpload('Assessments/UploadAssessmentDocument', formData)
}

export const removeAssessmentDocument = (documentId: Guid) =>
  usingDelete(`Assessments/RemoveAssessmentDocument/${documentId}`)

export const createDocumentDownloadUrl = (documentId: Guid) => {
  const sessionToken = SessionUtils.getSessionToken() || ''
  return createProxyUrl(`assessments/getDocument?token=${sessionToken}&documentId=${documentId}`)
}
